// Action Types
export const SIGNAGE_ADD = 'SIGNAGE_ADD';
export const SIGNAGE_SET_CURRENT = 'SIGNAGE_SET_CURRENT';
export const SIGNAGE_GET_CURRENT = 'SIGNAGE_GET_CURRENT';
export const SIGNAGE_DELETE = 'SIGNAGE_DELETE';
export const SIGNAGE_GET_LIST = 'SIGNAGE_GET_LIST';
export const SIGNAGE_RESET = 'SIGNAGE_RESET';

// Initial State
const initialState = {
  signageList: [],
  signageCurrent: null,
};

const SignageRedux = (state = initialState, action) => {
  switch (action.type) {
    case SIGNAGE_ADD:
      // signageId, noticeMessage 중복 방지
      if (
        state.signageList.some(
          signage =>
            signage.signageId === action.payload.signageId ||
            (signage.data?.signage?.noticeMessage &&
              signage.data.signage.noticeMessage === action.payload.data?.signage?.noticeMessage)
        )
      ) {
        return state;
      }
      return {
        ...state,
        signageList: [...state.signageList, action.payload],
      };
    // case SIGNAGE_SET_CURRENT:
    //   return {
    //     ...state,
    //     signageCurrent: action.payload.detail || null,
    //   };
    case SIGNAGE_SET_CURRENT:
      return {
        ...state,
        signageList: action.payload.list || [],
      };
    case SIGNAGE_GET_CURRENT:
      return {
        ...state,
        signageCurrent: action.payload.detail || null,
      };
    case SIGNAGE_DELETE:
      return {
        ...state,
        signageList: state.signageList.filter(signage => signage.signageId !== action.payload.id),
      };
    case SIGNAGE_GET_LIST:
      return {
        ...state,
        signageList: action.payload.list || [],
      };
    case SIGNAGE_RESET:
      return initialState;
    default:
      return state;
  }
};

export default SignageRedux;
